import Swiper from "swiper";
import Foundation from 'foundation-sites'; 
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { isMobile } from './util';

gsap.registerPlugin(ScrollTrigger);

export class TimelineYearslider {
    constructor(element) {
        this.element = element;
        this.swiper = this.createSwiper(this.element); 
        this.slidingToClick = false; 
        this.dragged = false; 
}

    createSwiper(container) { 
        const _self = this;
        const swiper = new Swiper(container[0], {
            init: false,
            speed: 400,
            centeredSlides: true,
            slidesPerView: 4,
            preventClicksPropagation: false,
            slideToClickedSlide: true,
            spaceBetween: 20,
            breakpoints: {
                841: {
                    slidesPerView: 11,
                }
            }, 
            on: {
                slideChangeTransitionEnd: function() {
                    if (this.clickedIndex == this.activeIndex || _self.dragged) {
                        _self.slidingToClick = true;
                        const slide = this.slides[this.activeIndex];
                        const button = $('.year-select', slide);
                        const href = button.attr('href');
                        const linkedCard = $(href);

                        const headerHeight = Foundation.MediaQuery.upTo("medium") ? $('.site-header.mobile').height() :  $('.top-menu-container').height();
                        const yearSliderHeight = _self.element.outerHeight();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: linkedCard.offset().top - (headerHeight + yearSliderHeight ) - 20,
                        }, 500, function() {
                            gsap.to(linkedCard, {
                                duration: .8,
                                scale: 1.8,
                            })
                            gsap.to(linkedCard, {
                                duration: .8,
                                scale: 1,
                            })
                            _self.slidingToClick = false;
                            _self.dragged = false;
                        });
                    } 
                },
                touchEnd: function() {
                    _self.dragged = true;
                }
            }
        })

        return swiper;
    }

    attachScrollTrigger() {
        const headerHeight = isMobile() ? 58 : 65;
        const st = ScrollTrigger.create({
            trigger: this.element,
            start: `top ${headerHeight}`,
            endTrigger: 'body',
            end: 'bottom bottom',
            pin: true,
            pinSpacing: false,
            markers: false,
        })
        return st;
    }

    attachItemScrollTriggers() {
        const _self = this;
        this.swiper.slides.map(function(slide, i) {
            const button = $('.year-select', slide)
            const href = button.attr('href');
            const linkedCard = $(href); 

            const st = ScrollTrigger.create({
                trigger: linkedCard,
                start: 'top center',
                end: 'bottom center',
                markers: false,
                onEnter: function(e) {
                    if (typeof _self.swiper !== 'undefined' && !_self.slidingToClick) {
                        _self.swiper.slideTo(i);
                    }
                },
                onEnterBack: function(e) {
                    if (typeof _self.swiper !== 'undefined' && !_self.slidingToClick) {
                        _self.swiper.slideTo(i);
                    }
                },
            })

            button.on('click', function(e) {
                e.preventDefault();
            });
        });
    }

    hideYearSlider() {
        gsap.to(this.element, {
            duration: .2,
            autoAlpha: 0,
        });
    }

    showYearSlider() {
        gsap.to(this.element, {
            duration: .2,
            autoAlpha: 1,
        });
    }

    initialShowYearSlider() {
        gsap.to(this.element, {
            duration: .2,
            autoAlpha: 1,
        });
        this.swiper.init();
    }

}
